import { fadeIn } from 'ng-animate';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { trigger, transition, useAnimation } from '@angular/animations';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { CcssService } from '@services/ccss/ccss.service';
import { PromotionalsSetting } from '@interfaces/promotionals-setting.model';
import { SettingsService } from '@services/settings.service';
import { SubscriptionManager } from '@zelis/platform-ui-components';
import { TrackByUtilities } from '@utilities/trackByFn.utilities';
import { Breakpoints } from '@classes/breakpoints.class';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-promotional-benefits',
  templateUrl: './promotional-benefits.component.html',
  styleUrls: ['./promotional-benefits.component.scss'],
  animations: [
    trigger('fadeIn', [
      transition(
        '* => *',
        useAnimation(fadeIn, {
          params: { timing: 1.1 },
        })
      ),
    ]),
  ],
})
export class PromotionalBenefitsComponent
  implements OnInit, OnChanges, OnDestroy
{
  @Input() public hsa: boolean;
  @Input() public pharmacy: boolean;

  @Output() public enabled = new EventEmitter<boolean>();

  public cardWidth: string;
  public mappedCards: PromotionalsSetting[] = [];
  public trackByFnIndex: any = TrackByUtilities.trackByFnIndex;
  public showSsoTelehealth: boolean = false;
  public showSubtitle: boolean = null;

  private settings: PromotionalsSetting[] = [];
  private subscriptions = new SubscriptionManager();
  private widthValue: number = 384;

  constructor(
    public ccss: CcssService,
    public breakpoints: Breakpoints,
    private settingsService: SettingsService,
    private translateService: TranslateService
  ) {
    // account-specific settings for order and redirect_urls
    this.subscriptions.add(this.subscribeToSettings());
  }

  ngOnInit() {
    this.showSubtitle =
      this.translateService.instant('promotional_benefits_subtitle') !==
      'promotional_benefits_subtitle';
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && (changes.hsa || changes.pharmacy)) {
      this.filterSettingsByMemberInputs();
    }
  }

  ngOnDestroy() {
    this.subscriptions.destroy();
  }

  private filterSettingsByMemberInputs(): void {
    this.mappedCards = this.settings.filter((setting: PromotionalsSetting) => {
      // member-specific benefits
      return this[setting.type];
    });

    this.enabled.emit(this.mappedCards.length > 0);

    this.setCardWidth();
  }

  private setCardWidth(): void {
    if (this.mappedCards.length === 1) {
      this.cardWidth = this.widthValue * 2 + 'px';
    } else {
      this.cardWidth = this.widthValue + 'px';
    }
  }

  private subscribeToSettings(): Subscription {
    return this.settingsService
      .getSetting('promotionals')
      .pipe(filter((response) => response && !!response.length))
      .subscribe((response: []) => {
        this.settings = response;
        this.filterSettingsByMemberInputs();
      });
  }
}
